//
import Service from '@/services/api/service'
import PurchaseOrderEditedModel from '@/models/Purchase/PchPurchaseOrderEdited'

/**
 * This class describes a pch purchase order edited.
 *
 * @class      PchPurchaseOrderEdited (name)
 */
export default class PchPurchaseOrderEdited extends Service {

  /**
   * Return the pch purchase order edited resource.
   *
   * @return     {Object}  The pch purchase order edited model
   */
  resource() {
    return PurchaseOrderEditedModel
  }

  /**
   * Returns a pch purchase order edited list.
   *
   * @return     {Object}  The pch purchase order edited list request.
   */
  toList() {
    return this
      .append('')
      .include(
        //'pch_purchase_order',
        //'pch_purchase_order.pch_detail_purchase_orders.wh_product',
        'pch_purchase_order_state',
        'g_originator_user.hr_employee',
        //'g_authorizer_user.hr_employee',
        'pch_detail_purchase_order_editeds',
        //'pch_detail_purchase_order_editeds.wh_product',
        //'pch_detail_purchase_order_editeds.wh_product_service',
      )
  }
}
